import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { roleAllList } from '../../../../store/actions/menuActions'
import { userUpdate, userEdit } from '../../../../store/actions/authActions'

const UserEdit = () => {
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [password, setpassword] = useState('')
  const [roles, setrole] = useState('')

  const dispatch = useDispatch()
  const history = useHistory()
  const id = localStorage.getItem('id_user');

  const datauserUpdate = useSelector(state => state.userUpdate)
  const { validation } = datauserUpdate

  const datauserEdit = useSelector(state => state.userEdit)
  const { user } = datauserEdit
  
  useEffect(() => {
    dispatch(userEdit(id))
    dispatch(roleAllList('MY'))
  }, [id])

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("user-edit")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);
  
    const dataLogin = useSelector((state) => state.login);
    let { userInfo } = dataLogin;

  const dataroleAllList = useSelector(state => state.roleAllList)
  const { role } = dataroleAllList

  useMemo(() => {
    if (user) {
      setname(user.name)
      setemail(user.email)
      setrole(user.id_role)
    }
  }, [user])

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(userUpdate(name, roles, email, password, id, history))
  }

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit User</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" 
                    className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                    name="name" 
                    required 
                    onChange={(e) => setname(e.target.value)}
                    value={name}
                  />
                  
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['name']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" 
                    className={ validation.length !== 0 && validation['email'] ? 'form-control parsley-error' : 'form-control' }
                    name="email" 
                    required 
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                  />
                  
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['email']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input type="password" 
                    className={ validation.length !== 0 && validation['password'] ? 'form-control parsley-error' : 'form-control' }
                    name="new_password"
                    onChange={(e) => setpassword(e.target.value)}
                    value={password}
                  />
                  
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['password']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className='form-group'>
                  <label for="role">Role</label>
                  <select 
                    className={ validation.length !== 0 && validation['role'] ? 'form-control parsley-error' : 'form-control' }
                    required onChange={(e) => setrole(e.target.value)} value={role}>
                    <option disabled selected value="">Select Role</option>
                    {
                      role.map((item, index) => {
                        return(
                          <option key={index} value={item.id}>{item.name}</option>
                        )
                      })
                    }
                  </select>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['role']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserEdit
